export class UsuarioSeg {
  id: number;
  idUsuarioSeg: number;
  nomeUsuarioSeg: string;
  sobrenomeUsuarioSeg: string;
  perfilUsuarioSeg: string;
}